module.exports = __webpack_public_path__ + "img/RMR Home Page - OLD.6b8f7b8b.png";